import React from 'react';
import PropTypes from 'prop-types';

import ProductListingPageDescriptionUI from 'components/consumer/ProductListingPageDescriptionUI';

const ProductListingPageDescriptionShell = ({
  pageLongDescription = '',
  pageName = '',
}) => {
  if (!pageLongDescription && !pageName) {
    return null;
  }

  return (
    <div className="mx-5 md:mx-0 md:mt-24">
      <ProductListingPageDescriptionUI label={pageName}>
        {pageLongDescription}
      </ProductListingPageDescriptionUI>
    </div>
  );
};

ProductListingPageDescriptionShell.propTypes = {
  pageLongDescription: PropTypes.string,
  pageName: PropTypes.string,
};

export default ProductListingPageDescriptionShell;
